import { Action } from 'react-fetching-library';

export const getFile: Action = {
  method: 'GET',
  endpoint: 'files',
};
